import api from '../../api'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    all: [],
    placeFull: {}
  }
}

const state = getDefaultState()

const getters = {
  getPlaces: (state) => state.all,
  getPlace: (state) => (id) => {
    return state.all.find(place => place.id == id)
  },
  getPlacesByGenre: (state) => (genre) => {
    return state.all.filter(p => p.genreIds.includes(genre.id))
  },
  getPlacecByGenreWithDistance: (state) => (route, genreId) => {
    const from = route.points[0]
    const to = route.points.slice(-1)[0]

    // NOTE: getterなのにmutation的な処理をしてしまっているのをどうにかしたい
    return state.all
      .filter(place => place.genreIds.includes(genreId))
      .map(place => {
        return Object.assign(place, { distance: distanceBetween(from, to, place) })
      })
  },
  getFilteredPlaces: (state, _getters, _rootState, rootGetters) => {
    const filter = rootGetters['user/getFilter']
    const on = Object.keys(_.pickBy(filter, (value) => value))

    return state.all.filter(place => {
      return _.intersection(place.genreIds, on).length > 0
    })
  },
  getPlaceFull: (state) => state.placeFull
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      const center = rootGetters['map/getCenter']
      const location = String(center.lat) + "," + center.lng
      api.getPlaces(rootGetters['user/getLang'], { location: location })
        .then((places) => {
          commit('setPlaces', places)
          resolve()
        })
    })
  },
  fetchPlaceGenres ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      const allForPlanTop = rootGetters['genres/getAllForPlanTop']
      var genres = []
      for (let i = 0; i < allForPlanTop.length; i++) {
        if (allForPlanTop[i].type !== 'favorite') {
          genres.push(allForPlanTop[i].id)
        }
      }
      const token = rootGetters['user/getToken']
      api.getPlaces(rootGetters['user/getLang'], { genres: genres.join(':'), token:token })
        .then((places) => {
          commit('setPlaces', places)
          resolve()
        })
    })
  },
  fetchPlaceLocation ({ rootGetters, commit }, center) {
    return new Promise((resolve) => {
      const location = String(center.latitude) + "," + center.longitude
      api.getPlaces(rootGetters['user/getLang'], { location: location })
        .then((places) => {
          commit('setPlaces', places)
          resolve()
        })
    })
  },
  fetchPlace ({ rootGetters,commit }, id) {
    return new Promise((resolve, reject) => {
      api.getPlace(id, rootGetters['user/getLang'])
        .then((place) => {
          commit('setPlaceFull', place)
          resolve(place)
        })
        .catch(() => reject())
    })
  },
  updateFavoritePlace({ commit }, { id, favoriteId, favorited }) {
    commit('setFavoritePlace', { id, favoriteId, favorited })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setPlaces (state, places) {
    state.all = places
  },
  setPlaceFull (state, place) {
    state.placeFull = place
  },
  setFavoritePlace (state, { id, favoriteId, favorited }) {
    var place = state.all.find(place => place.id == id)
    if (place !== undefined) {
      if (favorited) {
        place.genreIds.push(favoriteId)
      } else {
        var index = place.genreIds.indexOf(favoriteId)
        if (index !== -1) {
          place.genreIds.splice(index, 1)
        }
      }
    }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

/**
 * Private function
 */
// 距離を取得
function distanceBetween(from, to, place) {
  const d1 = getDistance(
    from.location.latitude,
    from.location.longitude,
    place.location.latitude,
    place.location.longitude
  )
  const d2 = getDistance(
    to.location.latitude,
    from.location.longitude,
    place.location.latitude,
    place.location.longitude
  )

  return Math.round((d1 + d2 / 2) * 100) / 100
}

function getDistance(lat1, lng1, lat2, lng2) {
  lat1 *= Math.PI / 180;
  lng1 *= Math.PI / 180;
  lat2 *= Math.PI / 180;
  lng2 *= Math.PI / 180;
  const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))

  return d;
}
